var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Warning-Triangle--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Warning Triangle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-triangle--frame-alert-warning-triangle-exclamation-caution"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ffe70d",
    fillRule: "evenodd",
    d: "M6.21769 0.226033c0.23555 -0.1439857 0.50627 -0.22017362 0.78234 -0.22017362 0.27607 0 0.54678 0.07618792 0.78233 0.22017362 0.23555 0.143986 0.42679 0.350183 0.55267 0.595886l0.00223 0.004362 -0.00002 0.000011L13.8365 11.8249l0.0004 0.0007c0.1148 0.2281 0.1695 0.4819 0.1588 0.7371 -0.0107 0.2555 -0.0865 0.504 -0.2203 0.7219 -0.1338 0.2179 -0.321 0.398 -0.544 0.5232 -0.2229 0.1252 -0.4742 0.1913 -0.7299 0.1921l-0.0015 0H1.50003l-0.00152 0c-0.25569 -0.0008 -0.506947 -0.0669 -0.729898 -0.1921 -0.22295 -0.1252 -0.410196 -0.3053 -0.543955 -0.5232 -0.1337584 -0.2179 -0.2095892 -0.4664 -0.22029075 -0.7219 -0.01068905 -0.2552 0.04395355 -0.5089 0.15874275 -0.737l0.000404 -0.0008L5.66281 0.826292 5.665 0.821908l0.00003 0.000011c0.12587 -0.245703 0.31712 -0.4519 0.55266 -0.595886ZM7 4.125c0.41421 0 0.75 0.33579 0.75 0.75v3.25c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-3.25c0 -0.41421 0.33579 -0.75 0.75 -0.75Zm1 6.75c0 0.5523 -0.44772 1 -1 1s-1 -0.4477 -1 -1 0.44772 -1 1 -1 1 0.4477 1 1Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleIcon);
export default __webpack_public_path__ + "static/media/warning-triangle-icon.2a593fb740ee69a2718ec986eac00fca.svg";
export { ForwardRef as ReactComponent };